'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _calendar = require('./calendar.controller');

var _calendar2 = _interopRequireDefault(_calendar);

var _sendSms = require('./send-sms/send-sms.controller');

var _sendSms2 = _interopRequireDefault(_sendSms);

var _session = require('./modal/session.controller');

var _session2 = _interopRequireDefault(_session);

var _editSession = require('./modal/edit.session.controller');

var _editSession2 = _interopRequireDefault(_editSession);

var _colourCount = require('./colour-count/colour-count.controller');

var _colourCount2 = _interopRequireDefault(_colourCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('calendar', {
    url: '/calendar',
    template: require('./calendar.html'),
    controller: 'CalendarController',
    controllerAs: 'vm',
    authenticate: 'admin'
  });
}

exports.default = _angular2.default.module('calApp.calendar', ['calApp.auth', 'ui.router']).config(routes).controller('CalendarController', _calendar2.default).controller('SendSMSController', _sendSms2.default).controller('ColourCountController', _colourCount2.default).controller('SessionController', _session2.default).controller('EditSessionController', _editSession2.default).name;


// WEBPACK FOOTER //
// ./client/app/calendar/index.js